module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "vue-validate"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateForm('form-1')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input-error': _vm.errors.has('form-1.email')
    },
    attrs: {
      "type": "text",
      "name": "email"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.email')),
      expression: "errors.has('form-1.email')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.email')))]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Submit Form 1")])]), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateForm('form-2')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    class: {
      'input-error': _vm.errors.has('form-2.date')
    },
    attrs: {
      "type": "text",
      "name": "date"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.date')),
      expression: "errors.has('form-2.date')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('form-2.date')))]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Submit Form 2")])]), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "form-3"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateForm('form-3')
      }
    }
  }, [_c('custom-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "innerValue",
      "data-vv-name": "form-3.custom",
      "has-error": _vm.errors.has('form-3.custom')
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.custom')),
      expression: "errors.has('form-3.custom')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.custom')))]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Submit Form 3")])], 1), _vm._v(" "), _c('div', [_c('custom-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "innerValue",
      "data-vv-name": "custom",
      "label": "Email",
      "has-error": _vm.errors.has('custom')
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('custom')),
      expression: "errors.has('custom')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('custom')))]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validate
    }
  }, [_vm._v("Validate All")])], 1), _vm._v(" "), _c('div', [_c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:HH:mm'),
      expression: "'required|date_format:HH:mm'"
    }],
    class: {
      'input-error': _vm.errors.has('time1')
    },
    attrs: {
      "data-vv-name": "time1",
      "data-vv-value-path": "inputTime",
      "has-error": _vm.errors.has('time1')
    },
    model: {
      value: (_vm.time1),
      callback: function($$v) {
        _vm.time1 = $$v
      },
      expression: "time1"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('time1')),
      expression: "errors.has('time1')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('time1')))])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('date_format:DD/MM/YYYY'),
      expression: "'date_format:DD/MM/YYYY'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.date1),
      expression: "date1"
    }],
    class: {
      'input-error': _vm.errors.has('date1')
    },
    attrs: {
      "type": "text",
      "name": "date1"
    },
    domProps: {
      "value": (_vm.date1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('date1')),
      expression: "errors.has('date1')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('date1')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('date_format:DD/MM/YYYY|after:date1'),
      expression: "'date_format:DD/MM/YYYY|after:date1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.date2),
      expression: "date2"
    }],
    class: {
      'input-error': _vm.errors.has('date2')
    },
    attrs: {
      "type": "text",
      "name": "date2"
    },
    domProps: {
      "value": (_vm.date2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('date2')),
      expression: "errors.has('date2')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('date2')))]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Submit Form 4")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:datee2|date_format:DD/MM/YYYY'),
      expression: "'requiredWhenExist:datee2|date_format:DD/MM/YYYY'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.datee1),
      expression: "datee1"
    }],
    class: {
      'input-error': _vm.errors.has('datee1')
    },
    attrs: {
      "type": "text",
      "name": "datee1"
    },
    domProps: {
      "value": (_vm.datee1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datee1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('datee1')),
      expression: "errors.has('datee1')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('datee1')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:datee1|date_format:DD/MM/YYYY'),
      expression: "'requiredWhenExist:datee1|date_format:DD/MM/YYYY'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.datee2),
      expression: "datee2"
    }],
    class: {
      'input-error': _vm.errors.has('datee2')
    },
    attrs: {
      "type": "text",
      "name": "datee2"
    },
    domProps: {
      "value": (_vm.datee2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datee2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('datee2')),
      expression: "errors.has('datee2')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('datee2')))])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dtereq),
      expression: "dtereq"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    class: {
      'input-error': _vm.errors.has('dtereq')
    },
    attrs: {
      "type": "text",
      "maxlength": "10",
      "name": "dtereq",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.dtereq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dtereq = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtereq')),
      expression: "errors.has('dtereq')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtereq')))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.validateFields()
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5edd85c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vueValidate/component.vue
// module id = 3807
// module chunks = 1